export const categories = [
  {
    slug: "entertainment",
    name: "娱乐风波",
    desc: "艺人动态、代言与舞台之外的公开争议，按时间顺序梳理前因后果。",
    icon: "ri-fire-line",
  },
  {
    slug: "variety",
    name: "综艺现场",
    desc: "节目录制、赛制调整与成团名单相关的现场话题复盘。",
    icon: "ri-mic-line",
  },
  {
    slug: "screen",
    name: "影视动态",
    desc: "剧集播出、剪辑版本与收官口碑引发的讨论梳理。",
    icon: "ri-film-line",
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "音乐节、演唱会与演出流程相关的现场事件时间线。",
    icon: "ri-music-2-line",
  },
  {
    slug: "livestream",
    name: "网红直播",
    desc: "直播带货、选品与售后争议的完整经过整理。",
    icon: "ri-live-line",
  },
  {
    slug: "sports",
    name: "体育热议",
    desc: "联赛判罚、赛后申诉与赛程调整相关话题的过程复盘。",
    icon: "ri-basketball-line",
  },
];

export const events = [
  {
    id: "ev-01",
    slug: "cross-year-chorus-change",
    title: "跨年晚会合唱环节临时改歌事件",
    summary:
      "一场跨年晚会的压轴合唱在直播前数小时更换曲目，引发观众对节目单与彩排安排的集中讨论，事件在一天内经历爆料、回应与节目组说明三个阶段。",
    categorySlug: "variety",
    heat: 986000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20stage%20and%20microphone%20theme%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-01&orientation=landscape",
    tags: ["节目单", "直播", "临时调整"],
    updatedAt: "2026-09-10 09:40",
    timeline: [
      {
        time: "12 月 30 日 21:10",
        title: "节目单流出",
        desc: "晚会官方账号发布演出节目单，压轴为四人合唱曲目，随后有现场彩排照片在网上传播，曲目与节目单一致。",
      },
      {
        time: "12 月 31 日 15:20",
        title: "改歌传闻出现",
        desc: "有自称现场工作人员账号发帖称合唱曲目将临时更换，帖子未附任何素材，仅描述彩排流程变化。",
      },
      {
        time: "12 月 31 日 20:35",
        title: "直播画面印证",
        desc: "直播进行到压轴环节时，屏幕字幕显示的曲名与节目单不同，相关话题在十分钟内进入热榜前列。",
      },
      {
        time: "1 月 1 日 00:20",
        title: "演出方回应",
        desc: "演出方发布说明，表示更换曲目因版权授权时间差导致，已提前向现场观众播报，并对流程说明不到位致歉。",
      },
      {
        time: "1 月 1 日 10:00",
        title: "讨论回落",
        desc: "参与演唱的歌手转发说明并表示理解，话题热度在次日中午明显下降，事件基本收尾。",
      },
    ],
    cause:
      "压轴合唱曲目的版权授权在演出前一日才最终确认无法使用，节目组需要在极短时间内完成曲目替换与镜头调整。",
    development: [
      "授权时间差导致原定曲目不可用，节目组在彩排结束后临时更换曲目。",
      "更换决定只在现场与内部渠道传达，线上观众并未提前获知。",
      "节目单未同步更新，造成直播画面与官方节目单不一致。",
      "争议集中在说明是否及时，而非曲目本身的好坏。",
    ],
    result:
      "演出方致歉并承诺后续在节目单变更时同步更新线上信息，参与歌手均表示理解，观众讨论转向对演出流程管理的建议。",
    relatedIds: ["ev-05", "ev-08"],
  },
  {
    id: "ev-02",
    slug: "youth-drama-ending-edit",
    title: "青春剧收官夜结局剪辑争议",
    summary:
      "一部热播青春剧在大结局播出后，观众发现线上版本与点映版本结局镜头不同，围绕剪辑取舍展开持续三天的讨论。",
    categorySlug: "screen",
    heat: 872000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20film%20frames%20and%20editing%20timeline%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-02&orientation=landscape",
    tags: ["大结局", "剪辑版本", "点映"],
    updatedAt: "2026-09-09 19:15",
    timeline: [
      {
        time: "8 月 12 日 20:00",
        title: "点映场放映",
        desc: "剧集在三个城市举办线下点映，放映的结局包含一段两分钟的重逢镜头。",
      },
      {
        time: "8 月 18 日 22:10",
        title: "正片上线引发对比",
        desc: "线上正片大结局上线，观众发现重逢镜头被替换为开放式的过场镜头，相关对比截图开始扩散。",
      },
      {
        time: "8 月 19 日 11:30",
        title: "主创回应",
        desc: "编剧在个人账号说明两个版本均为拍摄素材，线上版本为配合播出时长做的取舍。",
      },
      {
        time: "8 月 20 日 16:00",
        title: "平台补充说明",
        desc: "播出平台表示将在片尾彩蛋栏目中放出被剪掉的重逢片段。",
      },
      {
        time: "8 月 21 日 18:40",
        title: "彩蛋上线",
        desc: "被剪片段以彩蛋形式上线，话题热度回落，讨论转为对版本差异的整理。",
      },
    ],
    cause:
      "剧集拍摄阶段为结局拍摄了多个版本，点映使用完整版，而线上播出受单集时长限制选择了较短的开放结局。",
    development: [
      "点映与正片版本不一致被观众逐帧比对发现。",
      "主创第一时间说明取舍原因，未回避版本差异。",
      "平台以彩蛋形式补发被剪片段，平息主要争议。",
    ],
    result:
      "被剪片段上线后，多数观众接受解释，事件以平台承诺未来点映与正片版本说明更清晰收尾。",
    relatedIds: ["ev-01", "ev-07"],
  },
  {
    id: "ev-03",
    slug: "music-festival-delay",
    title: "音乐节压轴演出延时风波全记录",
    summary:
      "一场户外音乐节因天气与设备检修导致压轴演出顺延五十分钟，现场观众与线上观众的反应经过一晚持续发酵。",
    categorySlug: "music",
    heat: 765000,
    status: "持续跟进",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20outdoor%20music%20festival%20stage%20and%20lights%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-03&orientation=landscape",
    tags: ["音乐节", "演出延时", "恶劣天气"],
    updatedAt: "2026-09-10 08:20",
    timeline: [
      {
        time: "9 月 6 日 21:40",
        title: "突发降雨",
        desc: "音乐节主舞台区域突降暴雨，演出方暂停舞台设备供电，现场广播引导观众有序避雨。",
      },
      {
        time: "9 月 6 日 22:15",
        title: "设备检修",
        desc: "受降雨影响，压轴演出所需的两组设备需要重新校准，官方账号发布顺延预告。",
      },
      {
        time: "9 月 6 日 23:05",
        title: "压轴开演",
        desc: "压轴演出顺延五十分钟后开演，演出时长为保证场地清场时间压缩了十二分钟。",
      },
      {
        time: "9 月 7 日 09:00",
        title: "退票诉求",
        desc: "部分提前离场的观众在票务平台提出部分退票诉求，主办方客服开始逐单登记。",
      },
      {
        time: "9 月 8 日 17:30",
        title: "补偿方案",
        desc: "主办方公布补偿方案，为提前离场观众提供下一届音乐节折扣券或部分退款二选一。",
      },
    ],
    cause:
      "演出当晚突降暴雨，压轴环节的舞台设备涉及高压供电与升降装置，出于安全考虑必须停演检修。",
    development: [
      "暴雨导致设备供电暂停，演出方启动应急预案引导避雨。",
      "压轴演出顺延五十分钟并压缩时长以配合场地清场时间。",
      "部分提前离场观众提出退票诉求，主办方开始登记。",
      "主办方公布折扣券或部分退款二选一的补偿方案。",
    ],
    result:
      "补偿方案公布后争议明显缓和，仍有观众希望延长登记周期，主办方表示登记通道将开放至月底。",
    relatedIds: ["ev-01", "ev-08"],
  },
  {
    id: "ev-04",
    slug: "livestream-origin-tracing",
    title: "直播带货产地溯源翻车事件复盘",
    summary:
      "某场农产品直播在展示产地溯源信息时，画面中的基地标识与官方登记信息不一致，事件在两天内经历下架、核查与说明。",
    categorySlug: "livestream",
    heat: 698000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20livestream%20screen%20and%20delivery%20boxes%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-04&orientation=landscape",
    tags: ["带货", "溯源", "售后"],
    updatedAt: "2026-09-08 14:05",
    timeline: [
      {
        time: "9 月 3 日 20:30",
        title: "溯源直播",
        desc: "直播间连线产地现场，画面中出现基地门牌与产品包装信息。",
      },
      {
        time: "9 月 3 日 22:50",
        title: "观众对比",
        desc: "有观众将直播截图与公开登记信息比对，指出门牌名称与登记主体不完全一致。",
      },
      {
        time: "9 月 4 日 10:00",
        title: "商品下架",
        desc: "涉事商品链接暂时下架，直播间发布公告称将对供应链环节进行核查。",
      },
      {
        time: "9 月 5 日 15:20",
        title: "核查说明",
        desc: "运营方说明该基地为合作分装点，门牌为分装点自用标识，产品主产地与登记主体一致。",
      },
      {
        time: "9 月 6 日 12:00",
        title: "售后通道",
        desc: "商品重新上架并同步公开分装流程说明，对已购用户开放无理由退换。",
      },
    ],
    cause:
      "直播画面展示的合作分装点使用了自用门牌标识，与产品主产地的公开登记名称不同，造成信息看起来对不上。",
    development: [
      "观众以截图比对发现标识差异，话题快速升温。",
      "商品链接先行下架，避免争议扩大。",
      "运营方公布分装点与主产地关系说明。",
      "重新上架并开放无理由退换通道。",
    ],
    result:
      "运营方完成流程说明与售后开放，事件收尾，讨论转向对溯源信息展示规范的关注。",
    relatedIds: ["ev-06", "ev-08"],
  },
  {
    id: "ev-05",
    slug: "variety-guest-exit",
    title: "综艺常驻嘉宾中途退出事件梳理",
    summary:
      "一档周播综艺的常驻嘉宾在播出第八期后不再出现，节目组与嘉宾双方先后说明原因，事件经历澄清与番外补录两个阶段。",
    categorySlug: "entertainment",
    heat: 654000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20television%20studio%20and%20empty%20host%20chair%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-05&orientation=landscape",
    tags: ["常驻嘉宾", "档期", "番外"],
    updatedAt: "2026-09-07 21:30",
    timeline: [
      {
        time: "7 月 26 日",
        title: "正常出镜",
        desc: "该嘉宾在第八期节目正常参与全部环节，片尾预告中仍有其镜头。",
      },
      {
        time: "8 月 2 日",
        title: "镜头减少",
        desc: "第九期播出后，观众发现其出镜时长明显减少，片尾预告中也未出现。",
      },
      {
        time: "8 月 3 日",
        title: "档期说明",
        desc: "节目组发布简短说明，表示因嘉宾后续档期与新剧组拍摄时间冲突，双方友好协商调整合作形式。",
      },
      {
        time: "8 月 5 日",
        title: "本人回应",
        desc: "嘉宾转发说明并感谢节目组，称会以飞行嘉宾身份在收官期回归。",
      },
      {
        time: "8 月 9 日",
        title: "番外补录",
        desc: "节目组放出为其补录的番外短片，包含未播出的游戏环节片段。",
      },
    ],
    cause:
      "嘉宾后续签约的新剧集拍摄周期与综艺录制档期重叠，双方在合约框架内协商调整合作形式。",
    development: [
      "合作形式调整未在第一时间公开，导致观众产生多种猜测。",
      "节目组以简短说明澄清档期原因。",
      "嘉宾本人转发互动，明确回归方式。",
      "补录番外短片补足未播内容。",
    ],
    result:
      "收官期中嘉宾以飞行身份回归，事件平稳收尾，未对节目口碑造成持续影响。",
    relatedIds: ["ev-01", "ev-02"],
  },
  {
    id: "ev-06",
    slug: "league-referee-appeal",
    title: "联赛争议判罚与赛后申诉完整经过",
    summary:
      "一场焦点战的终场前判罚引发双方球迷讨论，从现场抗议、赛后申诉到纪律委员会说明，整个过程历时四天。",
    categorySlug: "sports",
    heat: 612000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20stadium%20field%20and%20whistle%20shapes%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-06&orientation=landscape",
    tags: ["判罚", "申诉", "纪律委员会"],
    updatedAt: "2026-09-06 10:10",
    timeline: [
      {
        time: "9 月 1 日 21:50",
        title: "终场判罚",
        desc: "比赛第 88 分钟，主裁判判罚点球，回放显示身体接触发生在禁区内。",
      },
      {
        time: "9 月 1 日 22:40",
        title: "现场抗议",
        desc: "客队教练组在终场后与裁判组进行短暂沟通，现场情绪较为激动。",
      },
      {
        time: "9 月 2 日 14:00",
        title: "正式申诉",
        desc: "客队俱乐部提交书面申诉，请求对判罚依据作出说明。",
      },
      {
        time: "9 月 3 日 18:30",
        title: "裁判报告",
        desc: "联赛裁判委员会发布判罚报告，附回放角度说明判罚依据成立。",
      },
      {
        time: "9 月 4 日 11:00",
        title: "结果公布",
        desc: "联赛公布申诉结果，维持原判并对教练组不当行为作出提醒，事件收尾。",
      },
    ],
    cause:
      "终场前一次禁区内身体接触的判罚尺度存在主观判断空间，双方对接触程度理解不同。",
    development: [
      "现场抗议画面传播引发大范围讨论。",
      "客队俱乐部提交书面申诉，走正式流程。",
      "裁判委员会以多角度回放说明判罚依据。",
      "申诉结果维持原判并作出行为提醒。",
    ],
    result: "联赛维持原判，双方接受结果，相关讨论在结果公布后逐渐平息。",
    relatedIds: ["ev-03", "ev-04"],
  },
  {
    id: "ev-07",
    slug: "brand-poster-copy-clash",
    title: "品牌代言海报文案撞车事件梳理",
    summary:
      "两个品牌在同一周发布的新品海报被指文案高度相似，从网友比对到双方先后调整物料，事件在三天内完成回应闭环。",
    categorySlug: "entertainment",
    heat: 588000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20poster%20panels%20and%20typography%20blocks%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-07&orientation=landscape",
    tags: ["海报文案", "物料", "回应"],
    updatedAt: "2026-09-05 20:00",
    timeline: [
      {
        time: "8 月 28 日 10:00",
        title: "A 品牌发布",
        desc: "A 品牌发布新品海报，主视觉文案为一句四字短语搭配产品特写。",
      },
      {
        time: "8 月 29 日 14:20",
        title: "B 品牌发布",
        desc: "B 品牌发布同系列新品海报，文案结构与该四字短语高度相近。",
      },
      {
        time: "8 月 29 日 20:10",
        title: "网友比对",
        desc: "网友将两张海报并列比对，话题进入热榜，讨论集中在创意归属。",
      },
      {
        time: "8 月 30 日 11:40",
        title: "B 品牌调整",
        desc: "B 品牌更新海报文案并说明为设计团队独立创作，对相似表示遗憾。",
      },
      {
        time: "8 月 31 日 15:00",
        title: "A 品牌回应",
        desc: "A 品牌表示接受说明，双方未进一步争论，话题热度回落。",
      },
    ],
    cause:
      "两个品牌的新品均围绕同类材质展开宣传，主视觉文案在结构与用词上出现较高相似度，且发布间隔不足两天。",
    development: [
      "网友以并列截图推动话题传播。",
      "B 品牌先行调整物料并说明创作过程。",
      "A 品牌接受说明，未继续追究。",
    ],
    result:
      "双方物料均已更新，事件以友好沟通收尾，业内讨论转向对创意素材留档流程的重视。",
    relatedIds: ["ev-02", "ev-05"],
  },
  {
    id: "ev-08",
    slug: "talent-show-lineup-leak",
    title: "选秀节目成团名单泄露风波",
    summary:
      "一档选秀节目在总决赛前夜出现疑似成团名单截图，节目组连夜核查，事件从泄露、辟谣到最终结果公布历时一天。",
    categorySlug: "variety",
    heat: 542000,
    status: "已收尾",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20voting%20cards%20and%20stage%20spotlights%2C%20warm%20coral%20red%20amber%20and%20cream%20color%20palette%2C%20layered%20geometric%20paper%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=gossip-event-08&orientation=landscape",
    tags: ["成团名单", "泄露", "总决赛"],
    updatedAt: "2026-09-04 22:45",
    timeline: [
      {
        time: "9 月 2 日 23:10",
        title: "截图流出",
        desc: "社交平台出现一张疑似成团名单的截图，名单顺序与投票排名并列呈现。",
      },
      {
        time: "9 月 3 日 00:40",
        title: "节目组核查",
        desc: "节目组发布声明称已启动内部核查，并将对泄露来源保留追责权利。",
      },
      {
        time: "9 月 3 日 16:00",
        title: "初步说明",
        desc: "节目组说明总决赛投票数据在封存状态下由第三方机构保管，截图与真实结果无关。",
      },
      {
        time: "9 月 3 日 21:00",
        title: "总决赛直播",
        desc: "总决赛正常直播，实际成团名单与流传截图存在明显差异。",
      },
      {
        time: "9 月 3 日 22:40",
        title: "话题回落",
        desc: "结果公布后截图传闻不攻自破，话题热度在结果公布后一小时内快速回落。",
      },
    ],
    cause:
      "总决赛前夜社交平台出现一张排版工整的名单截图，因格式接近官方物料而快速传播。",
    development: [
      "节目组连夜启动核查并发布声明。",
      "说明投票数据由第三方机构在封存状态下保管。",
      "总决赛直播结果与截图明显不同，传闻自然瓦解。",
    ],
    result:
      "实际成团名单与传闻不符，事件收尾，节目组表示将复盘物料管理流程。",
    relatedIds: ["ev-01", "ev-05"],
  },
];

export const testimonials = [
  {
    name: "林一诺",
    role: "通勤党 · 每天地铁 40 分钟",
    text: "以前一个瓜要翻十几条帖才能拼出顺序，现在打开一条时间线就全看明白了，通勤路上刚好读完。",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20portrait%20avatar%20of%20a%20young%20woman%20with%20short%20hair%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20soft%20plain%20background%2C%20no%20text&width=200&height=200&seq=gossip-avatar-01&orientation=squarish",
  },
  {
    name: "周衍",
    role: "内容编辑 · 常做选题复盘",
    text: "前因后果是分开写的，这点很实在。做选题的时候直接看经过要点就够了，省下大量翻资料的时间。",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20portrait%20avatar%20of%20a%20young%20man%20with%20glasses%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20soft%20plain%20background%2C%20no%20text&width=200&height=200&seq=gossip-avatar-02&orientation=squarish",
  },
  {
    name: "苏晚",
    role: "大学生 · 爱追综艺",
    text: "最怕看到一半发现是旧闻，这里每条都标了最近更新时间，还会写明事件是不是已经收尾了。",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20portrait%20avatar%20of%20a%20student%20with%20ponytail%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20soft%20plain%20background%2C%20no%20text&width=200&height=200&seq=gossip-avatar-03&orientation=squarish",
  },
];

export const faqs = [
  {
    q: "热搜吃瓜事件梳理是怎么做的？",
    a: "我们会先把同一热点的公开信息按发布时间排队，再拆成前因、经过、结果三段，最后把关键节点整理成时间线。这样你不用在多条帖子之间来回对照，就能看清整件事的顺序。",
  },
  {
    q: "时间线上的时间准确吗？",
    a: "时间线节点取自公开可查的发布时间与官方说明。如果某个节点的时间只能精确到日期，我们会标注到日，不会为了看起来整齐而编造具体时刻。",
  },
  {
    q: "怎么判断一件事是不是已经结束了？",
    a: "每条事件都会标注状态，分为发酵中、持续跟进和已收尾。标注已收尾代表当事方或相关机构已经给出明确说明或处理结果，我们才会调整状态。",
  },
  {
    q: "热搜吃瓜会同步更新旧事件吗？",
    a: "会。如果一件事出现新的官方说明或处理进展，我们会在原时间线末尾追加节点并更新最近更新时间，而不是新开一条重复内容，方便你继续在原页面往下看。",
  },
  {
    q: "如何订阅瓜报？",
    a: "在首页或关于我们页面填写邮箱即可订阅。瓜报只在有值得复盘的事件更新时发送，不会频繁打扰，也可以随时回复邮件退订。",
  },
];